export const block = "SRa";
export default {block};